import { getGoals } from '../../configuration/get-goals.tsx';
import type { EagerLoadingDataFetcher } from './types.tsx';

export const goalsFetcher: EagerLoadingDataFetcher = {
	match: ({ query: { goal } }) => goal !== undefined,
	fetch: (sourceAri) => getGoals(sourceAri).map((goals) => ({ goals })),
};
